<template>
    <div class="header">
        <div class="container">
            <div class="call">咨询电话：13465818001</div>
            <div class="actions">
                <span v-if="!userInfo">
                    <router-link class="link" to="/login">登录</router-link>
                    <router-link class="link" to="/register">注册</router-link>
                </span>
                <el-dropdown v-else trigger="click">
                    <span>
                        {{ userInfo.email }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <div @click="loginOut">退出登录</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <router-link class="link" to="/shopcart">
                    购物车(
                    <strong class="cartitemnum">{{
                        (userInfo && userInfo.bookingNum) || 0
                    }}</strong>
                    )件
                </router-link>
                <router-link class="link" to="/center/order">我的订单</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/user';

import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'v-header',
    data() {
        return {
            userInfo: null,
        };
    },
    computed: {
        ...mapGetters(['reloadUser']),
    },
    watch: {
        reloadCartMum(val) {
            if (val) {
                this.getUserInfo();
            }
        },
        reloadUser(val) {
            if (val) {
                this.setreloadUserState(false);
                this.getUserInfo();
            }
        },
    },
    methods: {
        ...mapActions(['setreloadUserState', 'setUserInfo']),
        getUserInfo() {
            apis.getUserInfo().then(res => {
                this.userInfo = res.data;
                this.setUserInfo(this.userInfo);
            });
        },
        loginOut() {
            this.userInfo = null;
            localStorage.removeItem('authorization');
            this.$message.success('已退出登录');
            this.$router.push('/login');
            this.setreloadUserState(true);
        },
    },
    mounted() {
        this.getUserInfo();
    },
};
</script>

<style lang="less" scoped>
.header {
    width: 100%;
    height: 40px;
    background-color: #90929b;
    color: #fff;
    font-size: 12px;
    line-height: 40px;
    .container {
        display: flex;
        justify-content: space-between;
        .link {
            color: #fff;
            margin-left: 40px;
            text-decoration: none;
        }
        .link2 {
            color: #fff;
            text-decoration: none;
        }
        .el-dropdown {
            color: #fff;
            cursor: pointer;
        }
    }
}
</style>
